import { render, staticRenderFns } from "./CombinedDashboard.vue?vue&type=template&id=321073cb&scoped=true"
import script from "./CombinedDashboard.vue?vue&type=script&lang=js"
export * from "./CombinedDashboard.vue?vue&type=script&lang=js"
import style0 from "./CombinedDashboard.vue?vue&type=style&index=0&id=321073cb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "321073cb",
  null
  
)

export default component.exports